import { IdcardOutlined } from '@ant-design/icons'
import MaskedInput from 'antd-mask-input'
import { object } from 'prop-types'
import React from 'react'
import { FormItem, styleIconValidation } from './base/styles'
import { Widget, useUpdate, useValidation } from './base/widget'
import { CommonFields } from './base/widgetCommonFields'

export const CpfWidget = React.memo((props) => {
	const { data } = props

	const update = useUpdate(props)
	const [valid, setValid] = useValidation(props)

	return (
		<Widget
			{...props}
			icon={<Icon $error={!valid} />}
			onValidate={setValid}
			type={'CPF'}
			formItems={
				<div>
					<CommonFields data={data} update={update} />

					<FormItem label="Valor inicial" $width={'50%'}>
						<MaskedInput
							value={data.initialValue}
							onBlur={(e) => update({ initialValue: e.target.value })}
							mask="000.000.000-00"
						/>
					</FormItem>
				</div>
			}
		/>
	)
})

const Icon = styleIconValidation(IdcardOutlined)

CpfWidget.propTypes = {
	data: object,
}
